import React from 'react';
import EnterAmountDF from '../components/SimulatorsComponents/DefualtSimulators/EnterAmountDF';
import { getSubCategoryId } from '../utils/DictionaryManagementUtils';

//= ========================================================================
const Sim_G08_SplitPaymentEnterAmount = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => (
  <EnterAmountDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    amount={globJSON.configurations.services[getSubCategoryId(globJSON.screens[selectedScreen])].amount}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_G08_SplitPaymentEnterAmount;
